export default "https://cdn-static.gokick.com/assets/31d35e8a0a5d253fd42fea745a10067c9b91f7ab/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";